module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAGFBMVEUAAADwTEzvS0vxTEzwTEz/VVXvTEzvS0tbeNSnAAAACHRSTlMAtf9e2gPDtME5/HwAAABWSURBVHgBY8AAjEooQICBCVVAgYFJgYFZJQCkltXJAMgDIjALCIDiUAEGI4hyZQaYQBhEIBUmAAcUCDDCnYkuUEB1WwTQBQqA/CHlF/SohFuBsAgdAABDFRq9O9YNZgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/xqms.png
// module id = Zf8y
// module chunks = 1